import { supabase } from '@/integrations/supabase/client';

export type TenantLinkResponse = 'accept' | 'reject';

/**
 * The invitee accepts or rejects a pending co-tenant invite (plan §1.63).
 *
 * Goes through the `respond-tenant-link` edge function, never a direct table write: the function
 * authenticates the caller (`auth.getUser()` on the caller's JWT) before any query and answers
 * 403 unless `tenant_links.invitee_user_id` is the caller's own `users.id` (Conv 31/32) — the
 * link id sent from here proves nothing on its own. Shared by the inline box in „Współnajemcy”
 * and the manage pop-up, so both paths behave the same.
 *
 * Returns true on success; false on any error (network, 4xx, the function's `{ error }` body).
 */
export async function respondTenantLink(linkId: string, action: TenantLinkResponse): Promise<boolean> {
  try {
    const { data, error } = await supabase.functions.invoke('respond-tenant-link', {
      body: { linkId, action },
    });
    return !error && !(data as { error?: unknown } | null)?.error;
  } catch {
    return false;
  }
}
